module.exports = __webpack_public_path__ + "img/cursive-workbook_B0991CGTLR.3f225583.jpg";